import React from 'react';
import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '~/helpers/utils';

const buttonVariants = cva(
  'button',
  {
    variants: {
      variant: {
        primary: 'button--primary',
        primaryGradient: 'button--primary-gradient',
        secondary: 'button--secondary',
        secondaryGradient: 'button--secondary-gradient',
        blue: 'button--blue',
        default: 'button--default',
        outline: 'button--outline',
        outlineGrey: 'button--outline-grey',
        disabled: 'button--disabled',
      },
      size: {
        small: 'button--sm',
        medium: 'button--md',
        large: 'button--lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  }
);

export type ButtonVariant = NonNullable<VariantProps<typeof buttonVariants>['variant']>;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, size, className, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)

Button.displayName = "Button";

export { Button, buttonVariants };